import { create } from "zustand";
import { getCostCoverage } from "./api";

/** Which chat's Cost Breakdown receipt is open, and from when each chat can be priced. */
interface CostSheetState {
  companyId: string | null;
  /** The reply it was opened from (ms): its turn is priced. Absent = the latest task. */
  at: number | null;
  open: (companyId: string, at?: number | null) => void;
  close: () => void;
  /** companyId → first priceable moment (ms); null = nothing to price yet. */
  coverage: Record<string, number | null>;
  loadCoverage: (companyId: string) => void;
}

const inFlight = new Set<string>();
export const useCostSheet = create<CostSheetState>((set, get) => ({
  companyId: null,
  at: null,
  open: (companyId, at = null) => set({ companyId, at: at !== null && Number.isFinite(at) ? at : null }),
  close: () => set({ companyId: null, at: null }),
  coverage: {},
  loadCoverage: (companyId) => {
    if (inFlight.has(companyId)) return;
    inFlight.add(companyId);
    void Promise.resolve(typeof getCostCoverage === "function" ? getCostCoverage(companyId) : null)
      .then((since) => set({ coverage: { ...get().coverage, [companyId]: since ?? null } }))
      .catch(() => undefined)
      .finally(() => inFlight.delete(companyId));
  },
}));
